import { render, staticRenderFns } from "./features-showcase.vue?vue&type=template&id=5683bccc&scoped=true&"
import script from "./features-showcase.vue?vue&type=script&lang=ts&"
export * from "./features-showcase.vue?vue&type=script&lang=ts&"
import style0 from "./features-showcase.vue?vue&type=style&index=0&id=5683bccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5683bccc",
  null
  
)

export default component.exports